import { SubcriptionCreationPayload, ExtendedProduct } from 'store/products/types'

export const toSubscriptionFormValues = (product: ExtendedProduct): SubcriptionCreationPayload | null | any =>
  product ? product.subscriptionCreationRule : { lockedStatus: false }
